import script from "./confirm-check-toggle-applicable-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./confirm-check-toggle-applicable-modal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__